// skeleton/app/src/app/shared/components/share-dialog/share-dialog.component.ts

import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { GroupModel, UserGroupDataModel, UserGroupModel } from 'src/app/admin/models/group.model';
//import { isUndefined } from 'util';
import { Constants } from '../../constants';
import { UserActivityLogModel } from '../../models/userActivityLog.model';
import { BaseHttpService } from '../../services/basehttp.service';
import { GlobalsessionhandlerService } from '../../services/globalsessionhandler.service';
import { NotificationService } from '../../services/notifications.service';
import { ButtonSize, ButtonStyle, ButtonType } from '../inputs/button/button.model';
import { TextComponent } from '../inputs/text/text.component';
import { ModalSize } from '../view/modal/modal.model';
import { ShareDialogService } from './share-dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RE2JS } from 're2js';
import { StorageService } from '../../services/token-storage.service';

@Component({
  selector: 'app-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.scss'],
  providers: [ShareDialogService],
  standalone: false
})
export class ShareDialogComponent implements OnInit {
  removeUser(arg0: GroupModel[], _t49: any) {
    throw new Error('Method not implemented.');
  }

  @Input() shareId;
  @Input() shareGroupId;
  @Input() props: { shareapiPath, modalShareText, shareSuccessMsg, shareRedirectUrl, dashboardType };
  @Output() closeModal = new EventEmitter();

  constant: Constants = new Constants();
  modalSize = ModalSize.FitContent;

  @ViewChild(TextComponent, { static: false }) textComponent: TextComponent;
  saveBtnText: string = 'SAVE';
  btnXlarge = ButtonSize.Medium;
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;
  shareDataLoaded: boolean = false;
  selectedOrgId: string;

  users: any;
  masterGroups: GroupModel[] = [];
  userInfo: UserGroupDataModel = new UserGroupDataModel();
  selectedGroupList: GroupModel[] = [];
  organizationId: string;

  @ViewChild('searchUserInstance', { static: false }) searchUserInstance: ElementRef;

  searchUserformatter = (user: UserGroupModel) => user.fullName;
  searchGroupformatter = (user: GroupModel) => user.groupName;

  public set setSelectedGroup(value: GroupModel) {
    if (value !== undefined) {
      if (value['groupId']) {
        this.changeType(value);
        let grpExists = this.selectedGroupList.filter(x => x.groupId == value.groupId)[0];
        if (grpExists == null) {
          this.selectedGroupList.push(value as GroupModel);
        }
      }
      this.searchUserInstance.nativeElement.value = '';
    }
  }

  public set setSelectedUser(value: UserGroupModel | GroupModel) {
    if (value !== undefined) {
      if (value['userId']) {
        this.userInfo.users.push(value as UserGroupModel);
      } else if (value['groupId']) {
        this.changeType(value);
        this.userInfo.groups.push(value as GroupModel);
      }

      this.searchUserInstance.nativeElement.value = '';
    }
  }

  changeType(value) {
    return value as GroupModel;
  }

  constructor(
    private shareDialogService: ShareDialogService,
    private baseHttpService: BaseHttpService,
    private notificationService: NotificationService,
    private router: Router,
    private globalsession: GlobalsessionhandlerService,
    private spinnerService: NgxSpinnerService,
    private storage: StorageService
  ) { }

  searchUser = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => {
      if (term === '') return [];
      try {
        // Use RE2JS with simplified pattern for safe partial search (prevents ReDoS attacks)
        const caseInsensitivePattern = `(?i).*${term}.*`;
        if (this.props.dashboardType == 1) {
          return this.users
            .filter(user => RE2JS.matches(caseInsensitivePattern, user.fullName))
            .slice(0, 10);
        } else {
          return this.masterGroups
            .filter(x => RE2JS.matches(caseInsensitivePattern, x.groupName))
            .slice(0, 10);
        }
      } catch (error) {
        console.error('Search regex error:', error);
        // Fallback to simple string matching if regex fails
        if (this.props.dashboardType == 1) {
          return this.users
            .filter(user => user.fullName.toLowerCase().includes(term.toLowerCase()))
            .slice(0, 10);
        } else {
          return this.masterGroups
            .filter(x => x.groupName.toLowerCase().includes(term.toLowerCase()))
            .slice(0, 10);
        }
      }
    })
  );

  async ngOnInit() {
    this.spinnerService.show();

    if (this.props.dashboardType == 1) {
      let grpobj = this.globalsession.getSelectedGroupObj();
      if (grpobj != null) {
        this.selectedOrgId = grpobj.organizationId;
      } else {
        await this.baseHttpService.get(this.constant.getAllOrgs).toPromise().then(async results => {
          this.selectedOrgId = this.storage.get("OrganizationId");
        });
      }

      const users$ = this.baseHttpService.getById(this.constant.getAllUsersByOrg, this.selectedOrgId);
      const survey$ = this.baseHttpService.getById(this.constant.getSurveyById, this.shareId);
      const groups$ = this.baseHttpService.get(this.constant.getAllGroups);
      const workflow$ = this.baseHttpService.getById(this.constant.getWorkflow, this.shareId);

      forkJoin([users$, groups$, workflow$]).subscribe(results => {
        results[1] = results[1].filter(x => x.organizationId == this.selectedOrgId).map(ele => {
          ele.fullName = `${ele.groupName} (G)`;
          return ele;
        });

        let dtusers = results[0];
        results[1] = results[1].filter(x => x.groupName != '' && x.groupName != null && x.isDefault == false);

        const distinctThings = results[1].filter(
          (thing, i, arr) => arr.findIndex(t => t.groupId === thing.groupId) === i
        );

        this.masterGroups = distinctThings;

        // Add deleted users to all groups
        this.masterGroups.forEach(element => {
          element.deletedUsers = [];
        });

        this.users = [...dtusers, ...results[1]];

        let dtWf = results[2];
        if (dtWf.workflowId > 0) {
          this.users = [...dtusers, ...results[1]];
        }
      });
    } else {
      this.getGroups();
    }

    this.spinnerService.hide();
  }

  async getGroups() {
    await this.baseHttpService.getById(this.constant.getOrganizationByGroupId, this.shareGroupId).toPromise().then(result => {
      this.organizationId = result;
    });

    this.baseHttpService.getById(this.constant.getGroupsByOrganizationId, this.organizationId).subscribe(results => {
      let grps = results.filter(x => x.groupName != '' && x.groupName != null && x.isDefault == false);

      const distinctThings = grps.filter(
        (thing, i, arr) => arr.findIndex(t => t.groupId === thing.groupId) === i
      );

      this.masterGroups = distinctThings;

      // Add deleted users to all groups
      this.masterGroups.forEach(element => {
        element.deletedUsers = [];
      });
    });
  }

  close(evt) {
    this.closeModal.emit('close');
  }

  removeGroup(data, i) {
    data.splice(i, 1);
  }

  emitSaveAction(evt) {
    this.spinnerService.show();

    if (this.props.dashboardType == 1) {
      let userActivityObj = this.buildUserActivityOject("Select", "Survey Share");
      this.userInfo.userActivityLog = (userActivityObj != null ? userActivityObj : null);

      this.shareDialogService.addUserInfo(this.shareId, this.userInfo, this.props.shareapiPath).subscribe(res => {
        if (!res) {
          this.notificationService.showSuccess(this.props.shareSuccessMsg, "Successful!");
          this.redirectTo(this.props.shareRedirectUrl);
        } else {
          this.notificationService.showError("Sharing error, please try after some time", "Error");
        }
        this.close('close');
      });
    } else {
      if (this.selectedGroupList.length > 0) {
        this.shareDialogService.addGroupInfo(this.shareId, this.selectedGroupList, this.props.shareapiPath).subscribe(async res => {
          if (!res) {
            this.notificationService.showSuccess(this.props.shareSuccessMsg, "Successful!");
            this.redirectTo(this.props.shareRedirectUrl);
          } else {
            this.notificationService.showError("Sharing error, please try after some time", "Error");
          }
          this.close('close');
        });
      }
    }

    this.spinnerService.hide();
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri])
    );
  }

  buildUserActivityOject(action: string, actionItem: string): UserActivityLogModel {
    let userActivity = new UserActivityLogModel();
    userActivity.action = action;
    userActivity.actionItem = actionItem;
    return userActivity;
  }
}
